export default __webpack_public_path__ + "static/media/home.94059a4d.png";